let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("dCQnN")).then(() => parcelRequire('3u0fx'));